import React from "react";

const categories = [
  {
    name: "Electronics",
    image:
      "https://static.vecteezy.com/system/resources/thumbnails/024/841/280/small_2x/wireless-headphone-isolated-on-transparent-background-high-quality-bluetooth-headphone-for-advertising-and-product-catalogs-generative-ai-png.png",
  },
  {
    name: "Food",
    image:
      "https://static.vecteezy.com/system/resources/thumbnails/049/655/073/small_2x/a-plate-full-of-different-types-of-food-png.png",
  },
  {
    name: "Fashion",
    image:
      "https://img.favpng.com/22/1/23/christian-dior-se-handbag-lady-dior-tote-bag-png-favpng-sdZZdKUe2e3JLjPAMBbPCS0Ff.jpg",
  },
  {
    name: "Garden",
    image:
      "https://static.vecteezy.com/system/resources/thumbnails/035/874/235/small_2x/ai-generated-house-isolated-on-transparent-background-free-png.png",
  },
  {
    name: "Sports",
    image:
      "https://w7.pngwing.com/pngs/428/379/png-transparent-football-nike-mercurial-vapor-sport-ball-game-sport-sporting-goods.png",
  },
  {
    name: "Books",
    image: "https://pngfre.com/wp-content/uploads/book-82-300x222.png",
  },
  {
    name: "Toys",
    image:
      "https://static.vecteezy.com/system/resources/thumbnails/046/594/839/small/truck-plastic-toy-concept-free-png.png",
  },
  {
    name: "Beauty",
    image:
      "https://i.pinimg.com/736x/d5/52/3a/d5523aa47c6c4bd5bd1fb8c3ec623038.jpg",
  },
  {
    name: "Automotive",
    image:
      "https://www.vhv.rs/dpng/d/216-2167812_tesla-model-s-png-transparent-png.png",
  },
];

const CategorySection = ({ onCategorySelect }) => {
  return (
    <div className="bg-orange-200 py-1 m-3 rounded md:m-8 md:bg-red   md:py-8  px-1 md:px-12">

      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl md:text-2xl font-semibold text-gray-800">
          Category
        </h2>
        <button
          onClick={() => onCategorySelect(null)}
          className="text-sm text-blue-600 hover:underline font-medium cursor-pointer"
        >
          See All
        </button>
      </div>

     <div className="flex flex-wrap justify-left gap-[8px] px-2  lg:gap-x-8 lg:py-1">

        {categories.map((category, index) => (
          <div
            key={index}
            onClick={() => onCategorySelect(category.name)}
            className="flex-shrink-0 w-14 sm:w-16 md:w-24 flex flex-col items-center text-center cursor-pointer"
          >
            <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 rounded-[10px] lg:rounded-3xl  bg-gray-100 flex items-center justify-center overflow-hidden border border-gray-300 shadow-sm hover:shadow-md transition-shadow duration-300">
              <img
                src={category.image}
                alt={category.name}
                className="w-8 h-8 sm:w-10 sm:h-10 md:w-16 md:h-16 object-contain"
                loading="lazy"
              />
            </div>
            <span className="mt-1 text-[9px] sm:text-xs md:text-sm font-medium text-gray-700">
              {category.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategorySection;
